const FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS';
const FETCH_PRODUCT_DETAILS_SUCCESS = 'FETCH_PRODUCT_DETAILS_SUCCESS';
const FETCH_PRODUCT_DETAILS_ERROR = 'FETCH_PRODUCT_DETAILS_ERROR';

const defaultState = {
    product: {},
    loading: false,
    error: null
};

export default function productDetailReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_DETAILS:
            return {
                loading: true,
                error: null,
                product: {}
            }
        case FETCH_PRODUCT_DETAILS_SUCCESS:
            return {
                loading: false,
                error: null,
                product: action.payload
            }
        case FETCH_PRODUCT_DETAILS_ERROR:
            return {
                loading: false,
                error: action.payload,
                product: {}
            }
        default:
            return state
    }
}